import Eyebrow from './Eyebrow'
import Art from './Art'

// The header on an inner page. No photography: a trunk home earns a full bleed
// hero, a sub page does not, and Monzo’s inner pages are type on the canvas for
// the same reason. One H1, one lead, optional actions.
//
// `art` takes one of the apps’ own 160×120 pastel scenes (shared/heroMomentArt,
// onboardingSectionArt, workerSectionArt), the same pictures the apps put at the
// top of their own pastel heroes and sheets. On a wide page it sits to the right
// of the headline; on a text width page, and on every phone, it sits above the
// headline, which is the apps’ own order (art, then title). Decorative only: the
// words carry the meaning, so it is aria-hidden inside <Art>.

// `width` matches Section's: 'wide' for a page whose body is a full width grid,
// 'text' for one whose body is the narrow reading measure. ⚠️ They have to AGREE.
// /signup had a wide hero over a text-width form, so the heading started at the
// page margin and the form began 160px to its right, which reads as a mistake
// because it is one.
const WIDTHS = { wide: 'max-w-[1200px]', text: 'max-w-[720px]' }

export default function PageHero({ eyebrow, title, lead, art, width = 'wide', children }) {
  const side = art && width === 'wide'
  return (
    <header className="bg-canvas px-6 pb-4 pt-28 md:pt-32">
      <div className={`mx-auto ${WIDTHS[width]} ${side ? 'md:flex md:items-center md:justify-between md:gap-12' : ''}`}>
        <div className="min-w-0">
          {art && (
            <div className={side ? 'md:hidden' : ''}>
              <Art xml={art} className="mb-6 h-[90px] w-[120px] md:h-[120px] md:w-[160px]" />
            </div>
          )}
          {eyebrow && <Eyebrow className="mb-3">{eyebrow}</Eyebrow>}
          <h1 className="max-w-[820px] text-[34px] font-bold leading-[1.06] tracking-[-0.02em] sm:text-[44px] md:text-[56px]">
            {title}
          </h1>
          {lead && (
            <p className="mt-5 max-w-[600px] text-[18px] leading-relaxed text-ink-muted md:text-[21px]">
              {lead}
            </p>
          )}
          {children && <div className="mt-8 flex flex-wrap items-center gap-3">{children}</div>}
        </div>
        {/* Wrapped: Art's base class is inline-block, and two display utilities
            on one element resolve by stylesheet order, not class order. */}
        {side && (
          <div className="hidden shrink-0 md:block">
            <Art xml={art} className="h-[210px] w-[280px]" />
          </div>
        )}
      </div>
    </header>
  )
}
